import { useState, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import TrainingNeedElement from "../Components/TrainingNeedElement";
import TrainingUserNeedElement from "../Components/TrainingUserNeedElement";
import axios from "axios";
import "./TrainingNeedsReport.css";
import {
  FaChalkboardTeacher,
  FaUsers,
  FaCheckSquare,
  FaMoneyBill,
} from "react-icons/fa";

function TrainingNeedsReport() {
  const [isLoading, setIsLoading] = useState(false);
  const [benefitedUsers, setBenefitedUsers] = useState(0);
  const [approvedRequests, setApprovedRequests] = useState(0);
  const [completedTrainings, setCompletedTrainings] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [trainingsArray, setTrainingsArray] = useState([]);
  const [usersArray, setUsersArray] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  const getTrainingInfo = async () => {
    try {
      setIsLoading(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingRequests/dnc/report`,
        data: {
          language: state.language,
          startDate,
          endDate,
          organization: state.organization,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setBenefitedUsers(response.data.benefitedUsers);
      setApprovedRequests(response.data.approvedRequests);
      setCompletedTrainings(response.data.completedTrainings);
      setTotalCost(response.data.totalCost);
      setTrainingsArray(response.data.trainingsArray);
      setUsersArray(response.data.usersArray);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={9} className="dnc-report">
            <h2>Necesidades de capacitación</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <Col className="training-report-filters">
              <Form.Group className="mb-3">
                <Row className="justify-content-center align-items-end">
                  <Col lg={5}>
                    <Form.Label>Fecha de inicio</Form.Label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                    />
                  </Col>
                  <Col lg={5}>
                    <Form.Label>Fecha de término</Form.Label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                    />
                  </Col>
                  <Col lg={2}>
                    <Button variant="primary" onClick={() => getTrainingInfo()}>
                      Consultar
                    </Button>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
          </Col>
        </Row>

        <Row>
          <Col>
            <Col className="report-tile">
              <FaChalkboardTeacher />
              <h3>{approvedRequests}</h3>
              <p>Capacitaciones aprobadas</p>
            </Col>
          </Col>
          <Col>
            <Col className="report-tile">
              <FaCheckSquare />
              <h3>{completedTrainings}</h3>
              <p>Capacitaciones completadas</p>
            </Col>
          </Col>
          <Col>
            <Col className="report-tile">
              <FaUsers />
              <h3>{benefitedUsers}</h3>
              <p>Usuarios beneficiados</p>
            </Col>
          </Col>
          <Col>
            <Col className="report-tile">
              <FaMoneyBill />
              <h3>${totalCost.toLocaleString()}</h3>
              <p>Inversion realizada</p>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col className="mt-3">
            <h4>Capacitaciones brindadas</h4>
            <Col className="tile-list">
              {trainingsArray.length === 0 ? (
                <p>Sin resultados</p>
              ) : (
                trainingsArray.map((training) => (
                  <TrainingNeedElement
                    key={training.trainingId}
                    id={training.trainingId}
                    name={training.trainingName}
                    count={training.count}
                  />
                ))
              )}
            </Col>
          </Col>
          <Col className="mt-3">
            <h4>Usuarios capacitados</h4>
            <Col className="tile-list">
              {trainingsArray.length === 0 ? (
                <p>Sin resultados</p>
              ) : (
                usersArray.map((user) => (
                  <TrainingUserNeedElement
                    key={user.userId}
                    id={user.userId}
                    firstName={user.firstName}
                    lastName={user.lastName}
                    profileName={user.profileName}
                    profileName_english={user.profileName_english}
                    count={user.count}
                  />
                ))
              )}
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default TrainingNeedsReport;
